import React, { useEffect, useState } from "react";
import { TEXT_DEF } from "../../../constant/text";
import { Button } from "antd";
import ModalCommon from "../../../components/Modal";
import API from "../../../network/api";
import { RIGHTS } from "../../../constant/rights";
import { hasRight } from "../../../components/until/right";
import CustomInputNumber from "../../../components/common/CustomInputNumber";
import RenderSwitch from "../../../components/common/Switch";
import { ADMIN_TAIXIU } from '../../../network/api';

const TaiXiuSetting = () => {
  const [isMaintenance, setIsMaintenance] = useState()
  const [isUseBonusOriginal, setIsUseBonusOriginal] = useState()
  const [dataUp, setDataUp] = useState();
  const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [valueToUpdate, setValueToUpdate] = useState({});
  const labels = {
    ratesWinTest: 'Tỉ lệ lợi nhuận user chơi thử',
    ratesWin: 'Tỉ lệ lợi nhuận',
    tai: 'Tài',
    xiu: 'Xỉu',
    chan: 'Chẵn',
    le: 'Lẻ',
    '3-1': 'Tam bảo 1',
    '3-2': 'Tam bảo 2',
    '3-3': 'Tam bảo 3',
    '3-4': 'Tam bảo 4',
    '3-5': 'Tam bảo 5',
    '3-6': 'Tam bảo 6',
    '3-any': 'Tam bảo bất kỳ',
    'percentBonus': 'Tỉ lệ bonus',
    'highProfitBonus': 'Tỉ lệ bonus cho người chơi nếu turn trước thắng nhiều tiền',
    'soloBonus': 'Tỉ lệ bonus cho người chơi nếu chơi một mình',
    'houseWinStreakBonus': 'Tỉ lệ bonus cho người chơi nếu nhà cái thắng nhiều ván liên tiếp',
    'minConsecutiveHouseLoss': 'Số lần tối đa nhà cái thua liên tiếp',
    'maxConsecutiveHouseWins': 'Số lần nhà cái thắng liên tiếp tối đa trước khi hệ thống điều chỉnh tỉ lệ để đảm bảo cân bằng.',
    'ratesMaxUserWin': 'Tỉ lệ tối đa người chơi có thể thắng',
    'ratesMinUserWin': 'Tỉ lệ tối thiểu người chơi có thể thắng',
    'profitThresholdMultiplier': 'Hệ số nhân dùng để tính lợi nhuận mục tiêu của nhà cái trong khoảng giới hạn cho phép.'
  };
  const keysToFilter = ['isMaintenance', 'ratesWin', 'isUseBonusOriginal'];

  useEffect(() => {
    const getDataTaiXiu = async () => {
      console.log(`${ADMIN_TAIXIU}/getConfig`);
      const response = await API.get(`${ADMIN_TAIXIU}/getConfig`);
      const resultGame = response.data?.data?.result;
      setData(resultGame);
    };

    getDataTaiXiu();
  }, []);

  const showConfirm = (key) => {
    let params;
    const id = data?.find(x => x.key === key)?.id;
    switch (key) {
      case "isMaintenance":
        params = {
          key: "isMaintenance",
          value: isMaintenance.toString()
        }
        break;
      case "isUseBonusOriginal":
        params = {
          key: "isUseBonusOriginal",
          value: isUseBonusOriginal.toString()
        }
        break;
      case "ratesWin":
        params = {
          key: "ratesWin",
          value: valueToUpdate[key].toString()
        }
        break;
      case "tai":
        params = {
          key: "tai",
          value: valueToUpdate[key].toString()
        }
        break;
      case "xiu":
        params = {
          key: "xiu",
          value: valueToUpdate[key].toString()
        }
        break;
      case "chan":
        params = {
          key: "chan",
          value: valueToUpdate[key].toString()
        }
        break;
      case "le":
        params = {
          key: "le",
          value: valueToUpdate[key].toString()
        }
        break;
      case "3-1":
        params = {
          key: "3-1",
          value: valueToUpdate[key].toString()
        }
        break;
      case "3-2":
        params = {
          key: "3-2",
          value: valueToUpdate[key].toString()
        }
        break;
      case "3-3":
        params = {
          key: "3-3",
          value: valueToUpdate[key].toString()
        }
        break;
      case "3-4":
        params = {
          key: "3-4",
          value: valueToUpdate[key].toString()
        }
        break;
      case "3-5":
        params = {
          key: "3-5",
          value: valueToUpdate[key].toString()
        }
        break;
      case "3-6":
        params = {
          key: "3-6",
          value: valueToUpdate[key].toString()
        }
        break;
      case "3-any":
        params = {
          key: "3-any",
          value: valueToUpdate[key].toString()
        }
        break;
      case "ratesWinTest":
        params = {
          key: "ratesWinTest",
          value: valueToUpdate[key].toString()
        }
        break;
      case "percentBonus":
        params = {
          key: "percentBonus",
          value: valueToUpdate[key].toString()
        }
        break;
      case "highProfitBonus":
        params = {
          key: "highProfitBonus",
          value: valueToUpdate[key].toString()
        }
        break;
      case "soloBonus":
        params = {
          key: "soloBonus",
          value: valueToUpdate[key].toString()
        }
        break;
      case "houseWinStreakBonus":
        params = {
          key: "houseWinStreakBonus",
          value: valueToUpdate[key].toString()
        }
        break;
      case "minConsecutiveHouseLoss":
        params = {
          key: "minConsecutiveHouseLoss",
          value: valueToUpdate[key].toString()
        }
        break;
      case "maxConsecutiveHouseWinsy":
        params = {
          key: "maxConsecutiveHouseWins",
          value: valueToUpdate[key].toString()
        }
        break;
      case "ratesMaxUserWin":
        params = {
          key: "ratesMaxUserWin",
          value: valueToUpdate[key].toString()
        }
        break;
      case "ratesMinUserWin":
        params = {
          key: "ratesMinUserWin",
          value: valueToUpdate[key].toString()
        }
        break;
      case "profitThresholdMultiplier":
        params = {
          key: "profitThresholdMultiplier",
          value: valueToUpdate[key].toString()
        }
        break;
      default: break;
    }
    const dataReq = {
      id: id,
      params: params
    }
    setDataUp(dataReq);
    setIsShowModalConfirm(true)
  }

  const handleChangeSwitch = (e, key) => {
    if (key === "isMaintenance") {
      setIsMaintenance(e);
    } else if (key === "isUseBonusOriginal") {
      setIsUseBonusOriginal(e);
    }
  };

  const onRequest = async () => {
    if (!dataUp) return;
    await API.patch(`${ADMIN_TAIXIU}/updateConfig/${dataUp?.id}`, dataUp?.params)
      .then(response => {
        const result = response.data?.data;
        if (result?.code === 20004) {
          setLoading(true);
          setIsShowModalConfirm(false);
          setIsShowModalSuccess(true);
        }
      }).catch((error) => {
        console.log(error);
      })
  }

  const filteredData = data.filter((item) => item.key !== 'isMaintenance' && item.key !== 'isUseBonusOriginal');

  const sortedRatio = filteredData.sort((a, b) => {
    const withRatio = keysToFilter.includes(a.key);
    const withoutRatio = keysToFilter.includes(b.key);

    if (withRatio && !withoutRatio) return -1;
    if (!withRatio && withoutRatio) return 1;

    return 0;
  });

  const handleGetKey = (value) => {
    showConfirm(value);
  };

  const handleInputChange = (key, newValue) => {
    setValueToUpdate((prev) => ({ ...prev, [key]: Number(newValue) }));
  };

  const renderInputFields = () => {
    if (!data || data.length === 0) return;

    return (
      <>
        {sortedRatio.length > 0 &&
          sortedRatio?.map((item, index) => (
            <>
              <div className="col-12 flex" key={index}>
                <div className="col-3 text-left">{labels[item?.key] || item.key}</div>
                <div className="col-6">
                  <CustomInputNumber min={-1} max={9999} step={0.01} value={item?.value} onChange={(e) => handleInputChange(item.key, e)} />
                </div>
                {hasRight([RIGHTS.EditSettingOriginals]) ? (
                  <div className="col-3 text-left">
                    <Button
                      type="primary"
                      onClick={() => {
                        handleGetKey(item?.key);
                      }}
                    >
                      {TEXT_DEF.text0016}
                    </Button>
                  </div>
                ) : null}
              </div>
              <div style={{ margin: '10px 0px' }} />
            </>
          ))}
      </>
    );
  };

  return (
    <>
      {data ?
        <div className="col-12 flex-col"
          style={{ display: "flex", marginTop: 30, alignItems: "center" }}
        >
          <RenderSwitch data={data} labels={labels} handleChangeSwitch={handleChangeSwitch} hasRight={hasRight} handleGetKey={handleGetKey} />
          <div style={{ margin: "10px 0px" }} />
          {renderInputFields()}
          <div style={{ margin: "10px 0px" }} />
        </div> : null}
      {isShowModalConfirm && (
        <ModalCommon
          isShow={isShowModalConfirm}
          message={TEXT_DEF.text0071}
          txtBtnAcc={TEXT_DEF.text0008}
          textBtnClose={TEXT_DEF.text0072}
          actionNext={onRequest}
          close={() => { setIsShowModalConfirm(false); setDataUp(undefined) }}
        />
      )}
      {isShowModalSuccess && (
        <ModalCommon
          isShow={isShowModalSuccess}
          message={TEXT_DEF.text0073}
          txtBtnAcc={TEXT_DEF.text0007}
          actionNext={() => {
            setIsShowModalSuccess(false);
          }}
          close={() => {
            setIsShowModalSuccess(false);
          }}
        />
      )}
    </>
  )
}

export default TaiXiuSetting;